module.exports = __webpack_public_path__ + "assets/cancel-orange.963c133bd90648832b9e4bff8bdbcf72.svg";